import React from "react";
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
} from "@mui/material";
import { WB_SX } from "../../../ui/ux/uiTokens";

const PURPOSE_LABELS = {
    verification: "Verification",
    dkim: "DKIM",
};

const SesDnsRecordsTable = ({ records = [], verificationStatus }) => {
    if (!records?.length) {
        return (
            <Typography variant="body2" color="text.secondary">
                {verificationStatus === "SUCCESS"
                    ? "No DNS records required — identity is verified."
                    : "No DNS records to display."}
            </Typography>
        );
    }

    return (
        <TableContainer component={Paper} elevation={0} sx={{ ...WB_SX.card, overflow: "auto" }}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        {["Type", "Name", "Value", "Purpose"].map((h) => (
                            <TableCell key={h} sx={WB_SX.tableHeadCell}>{h}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {records.map((row, idx) => (
                        <TableRow key={idx} sx={WB_SX.tableRow}>
                            <TableCell sx={{ fontWeight: 600 }}>{row.type}</TableCell>
                            <TableCell sx={{ fontFamily: "monospace", fontSize: "0.8rem", wordBreak: "break-all" }}>
                                {row.name}
                            </TableCell>
                            <TableCell sx={{ fontFamily: "monospace", fontSize: "0.8rem", wordBreak: "break-all" }}>
                                {row.value}
                            </TableCell>
                            <TableCell>
                                <Chip
                                    size="small"
                                    label={PURPOSE_LABELS[row.purpose] || row.purpose || "—"}
                                    variant="outlined"
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default SesDnsRecordsTable;
